var VerifyNoticeView = Backbone.View.extend({
    el: '#verifyNotice',
    initialize: function (options) {
        this.resend = $('#resendVerify');
        this.throbber = $('#resendVerifyThrobber');
        
        this.model.bind('init', this.render, this);
    },
    events: {
        'click #resendVerify a': 'clickResend'
    },
    clickResend: function (e) {
        e.preventDefault();
        this.sending();
        this.model.resendVerifyEmail(_.bind(function (response) {
            if (response.success) {
                this.success();
            } else {
                this.failed();
            }
        }, this));
    },
    render: function () {
        if (this.model.isVerified()) {
            this.hide();
        } else {
            this.show();
        }
        this.model.bind('change:verified', this.render, this);
    },
    show: function () {
        // Show a reverify link if they joined more than a day ago
        this.resend.show();
        $(this.el).show();
    },
    hide: function () {
        $(this.el).slideUp('fast');
    },
    sending: function () {
        this.resend.hide();
        this.throbber.text('Sending confirmation…').show();
    },
    success: function () {
        this.resend.hide();
        this.throbber.text('Resent confirmation!').show();
    },
    failed: function () {
        this.resend.show();
        this.throbber.text('Sending failed').show();
    }
});

module.exports = VerifyNoticeView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/verifynoticeview.js
// module id = 532c
// module chunks = 1